const defaultState = {
  locationsStack: [],
  nonModalLocationsStack: [],
  storedLocation: null,
  currentLocation: null,
  lastNonModalLocation: null
};

//
// Action types
//

export const SET_LOCATION = "SET_LOCATION";
export const SET_STORED_LOCATION = "SET_STORED_LOCATION";
export const UNSET_STORED_LOCATION = "UNSET_STORED_LOCATION";
export const SET_CURRENT_ROUTES_GROUP = "SET_CURRENT_ROUTES_GROUP";
//
// Action creators
//

export function setLocation(location) {
  return {
    type: SET_LOCATION,
    location
  };
}

export function setStoredLocation(location) {
  return {
    type: SET_STORED_LOCATION,
    location
  };
}

export function unsetStoredLocation() {
  return {
    type: UNSET_STORED_LOCATION
  };
}

export function setCurrentRoutesGroup(routesGroup) {
  return {
    type: SET_CURRENT_ROUTES_GROUP,
    routesGroup
  };
}

function setLocationHandler(state, location) {
  const locationsStack = [...state.locationsStack];
  const nonModalLocationsStack = [...state.nonModalLocationsStack];

  const lastLocationIndex = locationsStack.length - 1;
  const lastLocation = lastLocationIndex >= 0 ? locationsStack[lastLocationIndex] : null;

  // Do not update location if it's the same than the one we already stored.
  // We include search/hash to ensure that deep links and anchor navigation are tracked.
  if (
    lastLocation &&
    lastLocation.pathname === location.pathname &&
    lastLocation.search === location.search &&
    lastLocation.hash === location.hash
  ) {
    return state;
  }

  // We add the current location to the stack to be used as a previous location
  // in the future
  locationsStack.push(location);

  // If the location is not flagged as modal, we make it available for modals
  // to use them when the close button is clicked
  if (!location.isModal) nonModalLocationsStack.push(location);
  const lastNonModalLocation = nonModalLocationsStack[nonModalLocationsStack.length - 1];

  // Make the previous location accessible from the state
  const previousLocation = locationsStack[locationsStack.length - 2];

  return {
    ...state,
    locationsStack,
    nonModalLocationsStack,
    lastNonModalLocation,
    previousLocation,
    currentLocation: location
  };
}

function setStoredLocationHandler(state, location) {
  return { ...state, storedLocation: location };
}

function unsetStoredLocationHandler(state) {
  const newState = { ...state };
  delete newState.storedLocation;

  return newState;
}

function setCurrentRoutesGroupHandler(state, routesGroup) {
  const newState = { ...state };
  const currentLocation = { ...newState.currentLocation, routesGroup };

  return { ...newState, currentLocation };
}

//
// Reducer and handlers
//
export default function locationsReducer(state, action) {
  switch (action && action.type) {
    case SET_LOCATION:
      return setLocationHandler(state, action.location);

    case SET_STORED_LOCATION:
      return setStoredLocationHandler(state, action.location);

    case UNSET_STORED_LOCATION:
      return unsetStoredLocationHandler(state);

    case SET_CURRENT_ROUTES_GROUP:
      return setCurrentRoutesGroupHandler(state, action.routesGroup);

    default:
      return state || defaultState;
  }
}
